import { Alert, Box, Stack, Typography } from '@mui/material'

import { useGetBidsPerJobAnalysisQuery } from 'generated/graphql'

import { BidsPerJobAnalysisCard } from './BidsPerJobAnalysisCard'
import { BidsPerJobAnalysisFilterCriteria } from './BidsPerJobAnalysisFilterCriteria'
import { BidsPerJobAnalysisFiltersForm } from './BidsPerJobAnalysisFilters'
import { useBidsPerJobAnalysisQueryInput } from './useBidsPerJobAnalysisQueryInput'

const BidsPerJobAnalysisContent = () => {
  const { start, end, hasValidRange, input } = useBidsPerJobAnalysisQueryInput()

  const { data, previousData, loading, error } = useGetBidsPerJobAnalysisQuery({
    variables: { input },
    skip: !hasValidRange,
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-and-network',
  })

  const histogram = data?.bidsPerJobAnalysis ?? previousData?.bidsPerJobAnalysis

  return (
    <Box>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', lg: 'flex-end' }}
        justifyContent='space-between'
        mb={3}>
        <Box>
          <Typography variant='h5' fontWeight={700} sx={{ color: 'primary.main' }}>
            Bids Per Job Analysis
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            See how many bids jobs received over a selected time period, and who won them.
          </Typography>
        </Box>

        <BidsPerJobAnalysisFiltersForm />
      </Stack>

      {error && (
        <Alert severity='error' sx={{ mb: 2 }}>
          Bids per job analysis failed to load. Please try again.
        </Alert>
      )}

      <BidsPerJobAnalysisCard
        histogram={histogram}
        loading={loading && !histogram}
        start={start}
        end={end}
      />
    </Box>
  )
}

export const BidsPerJobAnalysis = () => (
  <BidsPerJobAnalysisFilterCriteria>
    <BidsPerJobAnalysisContent />
  </BidsPerJobAnalysisFilterCriteria>
)
